import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderCatogoryCardModule } from '../modules/order-catogory-card/order-catogory-card.module';
import { OrderCategoryGroupComponent } from './order-category-group.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    OrderCategoryGroupComponent
  ],
  imports: [
    CommonModule,
    OrderCatogoryCardModule,
    TranslateModule
  ],
  exports: [OrderCategoryGroupComponent]
})
export class OrderCategoryGroupModule { }
